module.exports = __webpack_public_path__ + "MembersIcon-3ea2ce9102b6457e7e9f1c8c6b18ad10.svg";